<template>
  <div>
    <div v-for="n in news" :key="n.id">
      <div class="newsTitle">
        <h3 v-html="n.title"></h3>
      </div>
      <div class="newsType" v-html="n.label+' '+n.date"></div>
      <div class="newsText" v-html="n.text"></div>
      <hr>
    </div>
  </div>
</template>

<script>
export default {
  props: ["news"]
};
</script>
